import React from "react";
import { Card, CardBody } from "reactstrap";

const IconCard = ({className="mb-4", icon, title, value, id, L }) => {
  const color = ["act", "pub", "cal"].indexOf(id) > -1 && value === 0 ? "error-color" : ""
  return (
    <div className={`icon-row-item ${className}`}>
      <Card >
        <CardBody className="text-center">
          <i className={`${icon} ${color?? ""}`} />
          <p className="card-text font-weight-semibold mb-0">
            {L[title]}
          </p>
          <p className={`lead text-center ${color?? ""}`}>{value}</p>
        </CardBody>
      </Card>
    </div>
  );
};

export default IconCard;
